export const LANDMARK_CONNECTIONS = [
  [0, 1], // Nose to left eye
  [1, 2], // Left eye to left ear
  [2, 3], // Left ear to left shoulder
  [3, 7], // Left shoulder to right shoulder
  [0, 4], // Nose to right eye
  [4, 5], // Right eye to right ear
  [5, 6], // Right ear to right shoulder
  [6, 8], // Right shoulder to right elbow
  [9, 10], // Nose to mouth
  [11, 12], // Left shoulder to right shoulder
  [11, 13], // Left shoulder to left elbow
  [13, 15], // Left elbow to left wrist
  [12, 14], // Right shoulder to right elbow
  [14, 16], // Right elbow to right wrist
  [11, 23], // Left shoulder to left hip
  [12, 24], // Right shoulder to right hip
  [23, 24], // Left hip to right hip
  [23, 25], // Left hip to left knee
  [25, 27], // Left knee to left ankle
  [24, 26], // Right hip to right knee
  [26, 28] // Right knee to right ankle
];

export async function generateImageWithLandmarks(imageUrl, landmarks) {
  return new Promise((resolve, reject) => {
    if (!imageUrl) {
      reject(new Error('No image URL provided'));
      return;
    }

    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = imageUrl;

    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Set canvas dimensions
        canvas.width = image.width || 640; // Fallback width
        canvas.height = image.height || 480; // Fallback height

        // Draw image
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        // Draw landmarks and connections
        if (Array.isArray(landmarks) && landmarks.length > 0) {
          // Draw connections
          ctx.strokeStyle = '#00FF00';
          ctx.lineWidth = 2;
          LANDMARK_CONNECTIONS.forEach(([start, end]) => {
            const p1 = landmarks[start];
            const p2 = landmarks[end];
            if (p1 && p2 && p1.x != null && p1.y != null && p2.x != null && p2.y != null) {
              ctx.beginPath();
              ctx.moveTo(p1.x * canvas.width, p1.y * canvas.height);
              ctx.lineTo(p2.x * canvas.width, p2.y * canvas.height);
              ctx.stroke();
            }
          });

          // Draw points
          ctx.fillStyle = '#FF0000';
          landmarks.forEach((lm, index) => {
            if (lm && lm.x != null && lm.y != null) {
              ctx.beginPath();
              ctx.arc(lm.x * canvas.width, lm.y * canvas.height, 5, 0, 2 * Math.PI);
              ctx.fill();
            }
          });
        }

        resolve(canvas.toDataURL('image/png'));
      } catch (error) {
        reject(new Error(`Canvas rendering failed: ${error.message}`));
      }
    };

    image.onerror = () => reject(new Error('Failed to load image'));
  });
}
